<template>
  <div>
    <v-toolbar>
      <v-toolbar-title>
        <div>
          <div class="info--text">
            <v-icon medium>router</v-icon>
            <strong>Continuous Data</strong>
          </div>
          <div class="body-2">
            Summary
          </div>
        </div>
      </v-toolbar-title>
    </v-toolbar>
    <v-divider />
    <v-card v-if="wideForm" class="card-bg-4">
      <ContinuousDataSummary class="mb-2" @update:timeSeries="selectedTimeSeries = $event" />
      <ContinuousSummaryGraph class="mb-2" id="summaryChart" :station="continuousStation" :datasets="datasets" :selectedTimeSeries="selectedTimeSeries" />
      <v-layout>
        <v-flex xs12 lg6>
          <ContinuousInformation class="mr-1" :editForm="editForm" />
        </v-flex>
        <v-flex xs12 lg6>
          <Aliases class="ml-1" :editForm="editForm" />
        </v-flex>
      </v-layout>
    </v-card>
    <v-card v-else class="card-bg-4">
      <ContinuousDataSummary class="mb-2" @update:timeSeries="selectedTimeSeries = $event" />
      <ContinuousSummaryGraph class="mb-2" id="summaryChart" :station="continuousStation" :datasets="datasets" :selectedTimeSeries="selectedTimeSeries" />
      <ContinuousInformation :editForm="editForm" />
    </v-card>
  </div>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    SOURCE_TYPES,
  } from '@/store/MonitoringFeature/monitoringfeature'

  import ContinuousInformation from './Details/ContinuousInformation'
  import ContinuousDataSummary from './Details/ContinuousDataSummary'
  import ContinuousSummaryGraph from './Details/ContinuousSummaryGraph'
  import Aliases from './Summary/Aliases'

  const monitoringFeatures = createNamespacedHelpers('monitoringfeature')
  const dataSources = createNamespacedHelpers('datasource')

  export default {
    components: {
      ContinuousInformation,
      ContinuousDataSummary,
      ContinuousSummaryGraph,
      Aliases,
    },
    props: {
      editForm: Boolean,
      wideForm: Boolean,
    },
    data: () => ({
      selectedTimeSeries: null,
    }),
    computed: {
      ...monitoringFeatures.mapGetters(['currentFeatureDataSourceData',
        'currentFeatureDataSourceIndexByType',
      ]),
      ...dataSources.mapGetters(['dataSourceIndex']),
      dataSource() {
        return this.currentFeatureDataSourceIndexByType[SOURCE_TYPES.continuousAquarius]
      },
      continuousStation() {
        if (!this.dataSource) return
        let dataSourceId = this.dataSource.SourceId

        let currentFeatureDataSourceIndexByType = this.dataSourceIndex[SOURCE_TYPES.continuousAquarius]
        if (!currentFeatureDataSourceIndexByType) return
        let continuousStation = currentFeatureDataSourceIndexByType[dataSourceId]
        return continuousStation
      },
      continuousData() {
        return this.currentFeatureDataSourceData(SOURCE_TYPES.continuousAquarius)
      },
      datasets() {
        return (this.continuousData && this.continuousData.details && this.continuousData.details.Datasets) || []
      },
    },
  }
</script>